import React, { useState, useEffect } from 'react';
import {
    Box,
    Grid,
    Stack,
    Typography,
    TextField,
    IconButton,
    Button,
} from '@mui/material';
import { Save, Replay, Delete } from '@mui/icons-material';
import apiService from '@services/common';
import { useGlobalContext } from '@providers/globalProvider';
import { useDispatch } from 'react-redux';
import { updateBreadcrumb } from '@redux/commonReducer';

const OptionsPage = () => {
    const [options, setOptions] = useState({
        site_title: '',
        site_hotline: '',
        shop_address: '',
        shop_address_main: '',
        shop_address_sub: '',
        shop_email: '',
        shop_website: '',
        shop_fan_page: '',
        shop_youtube_channel: '',
        shop_company_code: '',
        id: 1,
    });

    const { showNotification, showLoading, hideLoading, showConfirm, closeConfirm } = useGlobalContext();
    const dispatch = useDispatch();

    const breadcrumb = [
        {
            name: 'Cấu hình website',
            url: 'options',
        },
    ];

    const styleIconButton = {
        backgroundColor: 'transparent',
        '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.04)',
        },
        border: 'none',
    };

    const loadData = () => {
        showLoading();
        // tuỳ API của anh: nếu anh dùng resource thì thường là options/1
        apiService
            .get('options/1')
            .then((res) => {
                const data = res.data.data || {};
                setOptions((prev) => ({
                    ...prev,
                    ...data,
                }));
                hideLoading();
            })
            .catch((err) => {
                console.error(err);
                hideLoading();
                showNotification('Đã có lỗi - vui lòng liên hệ quản trị viên', 'error');
            });
    };

    const handleChange = (field) => (e) => {
        const value = e.target.value;
        setOptions((prev) => ({
            ...prev,
            [field]: value,
        }));
    };

    const handleSave = () => {
        showLoading();
        const payload = { ...options };

        // Nếu anh code backend như mình gợi ý trước đó:
        //  - POST /options => update id=1
        //  - hoặc PUT /options/1
        // Ở đây mặc định dùng PUT /options/1 cho rõ ràng
        apiService
            .put(`options/1`, payload)
            .then((res) => {
                hideLoading();
                showNotification('Lưu cấu hình thành công', 'success');
                setOptions((prev) => ({
                    ...prev,
                    ...(res.data?.data || {}),
                }));
            })
            .catch((err) => {
                console.error(err);
                hideLoading();
                showNotification('Đã có lỗi xảy ra khi lưu cấu hình', 'error');
            });
    };

    const handleReset = () => {
        loadData();
    };

    useEffect(() => {
        loadData();
        dispatch(updateBreadcrumb(breadcrumb));
    }, []);

    return (
        <Box sx={{ width: '100%' }}>
            {/* Header */}
            <Box sx={{ mb: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="h5">Cấu hình website</Typography>
                <Stack direction="row" spacing={1}>
                    <IconButton sx={styleIconButton} onClick={handleReset}>
                        <Replay />
                    </IconButton>
                    <IconButton sx={styleIconButton} color="primary" onClick={handleSave}>
                        <Save />
                    </IconButton>
                </Stack>
            </Box>

            {/* Form dọc – 2 cột trên màn hình lớn */}
            <Box
                sx={{
                    p: 2,
                    borderRadius: 1,
                    border: '1px solid #ddd',
                    backgroundColor: '#fff',
                }}
            >
                <Box sx={{ width: '100%' }}>

                    <Stack spacing={2} sx={{ width: '100%' }}>
                        <TextField
                            label="Tiêu đề site"
                            value={options.site_title || ''}
                            onChange={handleChange('site_title')}
                            fullWidth
                            size="small"
                        />
                        <TextField
                            label="Hotline"
                            value={options.site_hotline || ''}
                            onChange={handleChange('site_hotline')}
                            fullWidth
                            size="small"
                        />
                        <TextField
                            label="Địa chỉ (chung)"
                            value={options.shop_address || ''}
                            onChange={handleChange('shop_address')}
                            fullWidth
                            size="small"
                        />
                        <TextField
                            label="Địa chỉ chính"
                            value={options.shop_address_main || ''}
                            onChange={handleChange('shop_address_main')}
                            fullWidth
                            size="small"
                        />
                        <TextField
                            label="Địa chỉ phụ"
                            value={options.shop_address_sub || ''}
                            onChange={handleChange('shop_address_sub')}
                            fullWidth
                            size="small"
                        />

                        <TextField
                            label="Email cửa hàng"
                            value={options.shop_email || ''}
                            onChange={handleChange('shop_email')}
                            fullWidth
                            size="small"
                        />
                        <TextField
                            label="Website"
                            value={options.shop_website || ''}
                            onChange={handleChange('shop_website')}
                            fullWidth
                            size="small"
                        />
                        <TextField
                            label="Fanpage Facebook"
                            value={options.shop_fan_page || ''}
                            onChange={handleChange('shop_fan_page')}
                            fullWidth
                            size="small"
                        />
                        <TextField
                            label="Kênh Youtube"
                            value={options.shop_youtube_channel || ''}
                            onChange={handleChange('shop_youtube_channel')}
                            fullWidth
                            size="small"
                        />
                        <TextField
                            label="Mã số công ty"
                            value={options.shop_company_code || ''}
                            onChange={handleChange('shop_company_code')}
                            fullWidth
                            size="small"
                        />
                    </Stack>
                </Box>

                {/* Nút lưu ở dưới thêm cho dễ bấm trên mobile */}
                <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end' }}>
                    <Button
                        variant="contained"
                        color="primary"
                        startIcon={<Save />}
                        onClick={handleSave}
                    >
                        Lưu cấu hình
                    </Button>
                </Box>
            </Box>
        </Box>
    );
};

export default OptionsPage;
